import EmptyLayout from '@platform/layouts/EmptyLayout.vue';
import LoginPage from '@platform/layouts/login/login-page.vue';
import type { RouteRecordRaw } from 'vue-router';
import type { defineComponent } from 'vue';
import type { AuthLoginCallback } from '@platform/layouts/login/auth-login';

type LoginPagesParameters = {
    withoutSupport?: boolean;
    coverComponent?: ReturnType<typeof defineComponent>;
    authLoginCallback?: AuthLoginCallback;
};

export const loginRouteGen = ({
    withoutSupport,
    coverComponent,
    authLoginCallback,
}: LoginPagesParameters = {}): RouteRecordRaw => ({
    name: 'AuthRoutePages',
    path: '/auth',
    component: EmptyLayout,
    children: [
        {
            name: 'LoginPage',
            path: 'login',
            component: LoginPage,
            props: { withoutSupport, coverComponent, authLoginCallback },
            meta: {
                public: true,
                label: 'Вход',
            },
        },
        {
            name: 'ResetPasswordPage',
            path: 'password-forget',
            component: () => import('@platform/layouts/login/forget-password.vue'),
            props: { withoutSupport, coverComponent },
            meta: {
                public: true,
                label: 'Восстановление пароля',
            },
        },
        {
            name: 'PasswordRecoveryPage',
            path: 'password-recovery',
            component: () => import('@platform/layouts/login/password-recovery.vue'),
            props: { withoutSupport, coverComponent },
            meta: {
                public: true,
                label: 'Восстановление пароля',
            },
        },
        {
            name: 'PasswordRegisterPage',
            path: 'password-register',
            component: () => import('@platform/layouts/login/password-recovery.vue'),
            props: { withoutSupport, coverComponent, isRegister: true },
            meta: {
                public: true,
                label: 'Регистрация',
            },
        },
    ],
});
